<div class="wg-container">
<h4 class="wg-area-heading text-dark">{{config.title}}</h4>
	{{#each config.data}}
		{{!--contains one two or more bars as group. For more than two bars, additional css has to be defined--}}
		<div class="wg-label ie-col-span-2 ie-row-4 ie-col-{{CALCULATE 1 '+' @index}}">{{name}}</div>
		<div class="multi-bar-container ie-row-3 ie-col-{{CALCULATE 1 '+' @index}} "
			style="grid-template-columns: repeat({{OBJVALUE ../config 'columnCount'}},1fr)">
			{{#each bar}}
				<div class="ie-col-{{CALCULATE 1 '+' @index}} ie-row-6 bar tc-background-{{color}}" style="height: {{height}}px;"></div>
			{{/each}}
		</div>
	{{/each}}
	{{#each config.data}}
		<div class="multi-bar-container ie-sub-row ie-row-3 ie-col-{{CALCULATE 1 '+' @index}} " style="grid-template-columns: repeat({{OBJVALUE ../config 'columnCount'}},1fr)">
			{{#each bar}}
				<div class="ie-col-{{CALCULATE 1 '+' @index}} ie-row-2 tc-{{color}} ">
					<div>
						<b>{{value}}&nbsp;{{unit}}</b>
					</div>
				</div>
			{{/each}}
		</div>
	{{/each}}
	<div class="wg-area-legend">
		{{#each config.legendItems}}
			<span class="{{color}} m-l-5"><i class="fa fa-square"></i> {{text}}</span>
		{{/each}}
	</div>
</div>
